import { Autocomplete, Divider, Grid, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import dashboardStyles from './../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss'
import autoCompleteStyles from './../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import AddIcon from '@mui/icons-material/Add';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import EditIcon from '@mui/icons-material/Edit';
import IconsColor from '../../../../../utility/iconsColor';
import styles from './../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import textStyles from './../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'
import CloseIcon from '@mui/icons-material/Close'
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { primaryColor } from '../../../../../../utils/colors';
import Required from '../../../../../utility/required';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { ACTION_TYPE_NAME, isSendOrderPaymentInfoSystemAPIExist } from '../../../flowBuilderConstants';
import { TEMPLATE_TYPES } from '../../../../channels/global/whatsapp/templates/utils';
import { filterAutocompleteOptionsWithException } from '../../../../../../utils/constants';
import { AiExtractValueCheckbox, AiExtractValueLabel } from './aiExtractValueField';

const initialPayloadFieldData = [
    {
        payload_field_key: "Payload 1",
        payload_field_data: {
            payload_field_id: 1,
            payload_field_name: "Test",
            payload_field_fallback_value: "test"
        }
    },
    {
        payload_field_key: "Payload 2",
        payload_field_data: {
            payload_field_id: 2,
            payload_field_name: "Test 2",
            payload_field_fallback_value: "test2"
        }
    },
    {
        payload_field_key: "Payload 3",
        payload_field_data: {
            payload_field_id: 3,
            payload_field_name: "Test 3",
            payload_field_fallback_value: "test3"
        }
    },
    {
        payload_field_key: "Payload 1",
        payload_field_data: {
            payload_field_id: 1,
            payload_field_name: "Test",
            payload_field_fallback_value: "test"
        }
    },
]

interface payloadTableInterface {
    setFlagDataCollectionPopup: (value: boolean) => void,
    actionData: any,
    stepAction: any
}

const PayloadFieldTable = (props: payloadTableInterface) => {
    const { setFlagDataCollectionPopup, actionData, stepAction } = props;
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const { onChangeCurrentActiveNodeConfig, nodes, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload 
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;

    const handleEditFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setFlagDataCollectionPopup(true);
        setFlagUpdateFieldData(true);
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
    }

    const handleDeleteFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
        if (setFlagDeleteData) {
            setFlagDeleteData(true)
        }
    }

    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        if (option.chatbot_custom_variable_configuration_id == "-1" && option.chatbot_custom_variable_name == "New Field") {
            return (
                <ul className={autoCompleteStyles.newTagNameUlElement}>
                    <Divider className={autoCompleteStyles.newTagDivider} />
                    <li {...props} style={{ minHeight: "auto", cursor: "pointer", padding: "10px 16px", display: "flex", alignItems: "center", gap: "5px", boxSizing: "border-box", outline: "none", color: primaryColor }} onClick={() => { setFlagDataCollectionPopup(true); }}>
                        <AddIcon />
                        <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>New Field</Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.chatbot_custom_variable_configuration_id}>
                <Grid container>
                    <ListItemText primary={option.chatbot_custom_variable_name} className={styles.listItemsStyle} />
                </Grid>
                <Grid container justifyContent={"end"} sx={{ maxWidth: "60px" }}>
                    <Grid item onClick={(e) => e.stopPropagation()}>
                        <ListItemIcon onClick={(event) => handleEditFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}
                        >
                            <EditIcon sx={{ height: "14px", width: "14px", fontSize: "14px" }} />
                        </ListItemIcon>
                    </Grid>
                    <Grid item onClick={(e) => e.stopPropagation()} paddingLeft={"12px"}>
                        <ListItemIcon onClick={(event) => handleDeleteFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}
                        >
                            <IconsColor height="14" width="14" iconName="DeleteIcon" fillColor="#7A7A7A" />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </li>
        )
    }

    const isTemplateExist = (type: string) => {
        const isTemplateActionExist = nodes?.find((node: any) => node?.id == currentActiveNodeConfig.nodeId)?.data?.find((data: any) => data?.action_type?.action_type_name == ACTION_TYPE_NAME['TEMPLATE']);
        if(isTemplateActionExist){
            const templateDetails = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => String(template?.whatsapp_template_id) == String(isTemplateActionExist?.action_data?.whatsapp_template?.whatsapp_template_id));
            if(type === 'flow_template'){
                return templateDetails?.whatsapp_template_flag_flow;
            } else if(type === "catalog_template") {
                return templateDetails?.whatsapp_template_type?.name?.toLowerCase() === TEMPLATE_TYPES['CATALOG']?.toLowerCase();
            }
        }
        return false;
    }

    const shouldShowVariableTable = () => {
        return (isTemplateExist('flow_template') || isTemplateExist('catalog_template') || isSendOrderPaymentInfoSystemAPIExist(nodes, currentActiveNodeConfig?.nodeId, currentActiveStaticWorkflow) || actionData?.filter((action: any) => action?.action_data?.value_type == "user_flow_message_payload")?.length > 0);
    }

    const getVariableTableTitle = () => {
        let title = 'Variable';
        if(isTemplateExist('flow_template')){
            title = 'Flow Output Variable';
        } else if(isTemplateExist('catalog_template') || isSendOrderPaymentInfoSystemAPIExist(nodes, currentActiveNodeConfig?.nodeId, currentActiveStaticWorkflow)) {
            title = 'Webhook Payload Key';
        }
        return title;
    }

    const onChangeOfAiExtraction = (payloadKey: any, value: boolean) => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
            { 
                ...payloadKey, 
                type: 'change_payload_config', 
                action_data: { 
                    ...payloadKey.action_data, 
                    flag_ai_extraction: value
                } },
            {
                updateType: "editExistingStepAction"
            }

        )
    }

    const isAiExtractCheckboxDisabled = (payloadKey: any) => {
        return !payloadKey?.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id;
    };

    const renderAiExtractionField = (payloadKey: any) => {
        return (
            <AiExtractValueCheckbox
                checked={payloadKey?.action_data?.flag_ai_extraction ?? false}
                disabled={isAiExtractCheckboxDisabled(payloadKey)}
                onChange={(value) => onChangeOfAiExtraction(payloadKey, value)}
            />
        );
    }

    return (

        <Grid container gap={"20px"} alignItems={"center"}>
            <Grid item xs={12}>
                <Grid container gap={"10px"}>
                    <Grid item>
                        <Typography sx={{fontSize: "15px", fontWeight: "600"}}>Payload Keys</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer sx={{ borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", maxHeight: "500px" }}>
                            <Table aria-label="simple table" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Payload Key</TableCell>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Field</TableCell>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}><AiExtractValueLabel /></TableCell>
                                        {/* {actionData.length > 1 && <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}></TableCell>} */}
                                    </TableRow>
                                </TableHead> 
                                <TableBody>
                                    {actionData?.filter((action: any) => action?.action_data?.value_type == "user_message_payload")?.length > 0 ? 
                                        actionData?.filter((action: any) => action?.action_data?.value_type == "user_message_payload")?.map((payloadKey: any, index: number) => {
                                            return (
                                                <TableRow className={dashboardStyles.cellRow} key={index}>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{payloadKey?.action_data.payload_key}</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle} sx={{ minWidth: "200px" }}>
                                                        <Autocomplete
                                                            className={`${autoCompleteStyles.contactFilterDropdownsInPopup}`}
                                                            options={customVariableList?.custom_variable_data ? [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), {
                                                                chatbot_custom_variable_configuration_id: "-1",
                                                                chatbot_custom_variable_name: "New Field",
                                                                chatbot_custom_variable_fallback_value: "",
                                                                flag_archived: false
                                                            }] : []}
                                                            getOptionLabel={(option) => option.chatbot_custom_variable_name || ''}
                                                            value={customVariableList?.custom_variable_data?.find((field: any) => field.chatbot_custom_variable_configuration_id == payloadKey.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) || null}
                                                            onChange={(e: React.SyntheticEvent, value: any) => {
                                                                onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
                                                                    { 
                                                                        ...payloadKey, 
                                                                        type: 'change_payload_config', 
                                                                        action_data: { 
                                                                            ...payloadKey.action_data, 
                                                                            chatbot_custom_variable_configuration: value,
                                                                            ...(!value && {
                                                                                flag_ai_extraction: false
                                                                            }) 
                                                                        } 
                                                                    },
                                                                    {
                                                                        updateType: "editExistingStepAction"
                                                                    }

                                                                )
                                                            }}

                                                            ListboxProps={{ style: { maxHeight: '150px', overflow: 'auto', paddingBottom: "50px" } }}
                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: customVariableDataInterface) => { return renderOptions(props, option); }}
                                                            renderInput={params => {
                                                                const { InputProps, ...restParams } = params;
                                                                const { startAdornment, ...restInputProps } = InputProps;
                                                                return (
                                                                    <TextField
                                                                        {...restParams}
                                                                        placeholder='Select Field'
                                                                        InputProps={{
                                                                            ...restInputProps,
                                                                            startAdornment: (
                                                                                <div style={{
                                                                                    maxHeight: "90px",
                                                                                    overflowY: 'auto',
                                                                                }}
                                                                                >
                                                                                    {startAdornment}
                                                                                </div>
                                                                            ),
                                                                        }}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                        {renderAiExtractionField(payloadKey)}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        :
                                        <TableRow className={dashboardStyles.cellRow}>
                                            <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                                                No Data Available
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Grid>
            {shouldShowVariableTable() &&
                <Grid item xs={12}>
                    <Grid container gap={"10px"}>
                        <Grid item>
                            <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}> 
                                {`${getVariableTableTitle()}s`} 
                                {actionData?.filter((action: any) => action?.action_data?.value_type == "user_flow_message_payload")?.length > 0 && <Required />}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer className={globalStyles.WritewizGlobaltable} sx={{ maxHeight: "500px" }}>
                                <Table aria-label="variable table" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>{getVariableTableTitle()}</TableCell>
                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Field</TableCell>
                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}><AiExtractValueLabel /></TableCell>
                                        </TableRow>
                                    </TableHead> 
                                    <TableBody>
                                        {actionData?.filter((action: any) => action?.action_data?.value_type == "user_flow_message_payload")?.length > 0 ? 
                                            actionData?.filter((action: any) => action?.action_data?.value_type == "user_flow_message_payload")?.map((payloadKey: any, index: number) => {
                                                return (
                                                    <TableRow className={dashboardStyles.cellRow} key={index}>
                                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{payloadKey?.action_data.payload_key}</TableCell>
                                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle} sx={{ minWidth: "200px" }}>
                                                            <Autocomplete
                                                                className={`${autoCompleteStyles.contactFilterDropdownsInPopup}`}
                                                                options={customVariableList?.custom_variable_data ? [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), {
                                                                    chatbot_custom_variable_configuration_id: "-1",
                                                                    chatbot_custom_variable_name: "New Field",
                                                                    chatbot_custom_variable_fallback_value: "",
                                                                    flag_archived: false
                                                                }] : []}
                                                                getOptionLabel={(option) => option.chatbot_custom_variable_name || ''}
                                                                value={customVariableList?.custom_variable_data?.find((field: any) => field.chatbot_custom_variable_configuration_id == payloadKey.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) || null}
                                                                onChange={(e: React.SyntheticEvent, value: any) => {
                                                                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
                                                                        { 
                                                                            ...payloadKey, 
                                                                            type: 'change_payload_config', 
                                                                            action_data: { 
                                                                                ...payloadKey.action_data, 
                                                                                chatbot_custom_variable_configuration: value,
                                                                                ...(!value && {
                                                                                    flag_ai_extraction: false
                                                                                }) 
                                                                            } 
                                                                        },
                                                                        {
                                                                            updateType: "editExistingStepAction"
                                                                        }

                                                                    )
                                                                }}
                                                                ListboxProps={{ className: autoCompleteStyles.listBoxCustomStyle }}
                                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "chatbot_custom_variable_name", "chatbot_custom_variable_configuration_id")}
                                                                renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: customVariableDataInterface) => { return renderOptions(props, option); }}
                                                                renderInput={params => {
                                                                    const { InputProps, ...restParams } = params;
                                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                                    return (
                                                                        <TextField
                                                                            {...restParams}
                                                                            placeholder='Select Field'
                                                                            InputProps={{
                                                                                ...restInputProps,
                                                                                startAdornment: (
                                                                                    <div style={{
                                                                                        maxHeight: "90px",
                                                                                        overflowY: 'auto',
                                                                                    }}
                                                                                    >
                                                                                        {startAdornment}
                                                                                    </div>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                           {renderAiExtractionField(payloadKey)}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                            :
                                            <TableRow className={dashboardStyles.cellRow}>
                                                <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                                                    No Data Available
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Grid>
            }
            {/* <TableContainer sx={{ borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", maxHeight: "300px" }}>
                <Table aria-label="simple table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Payload Key</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Field</TableCell>
                            {actionData.length > 1 && <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}></TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {actionData.map((payloadKey: any, index: number) => {
                            return <TableRow className={dashboardStyles.cellRow} key={index}>
                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                    <TextField
                                        className={textStyles.payloadTextField}
                                        value={payloadKey.action_data.payload_key}
                                        onChange={(event: any) => {
                                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...payloadKey, type: 'changing_payloadkey_value', action_data: { ...payloadKey.action_data, payload_key: event.target.value } },
                                                {
                                                    updateType: "editExistingStepAction"
                                                }
                                            )
                                        }}
                                    />
                                </TableCell>
                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle} sx={{ minWidth: "200px" }}>
                                    <Autocomplete
                                        className={`${autoCompleteStyles.contactFilterDropdownsInPopup}`}
                                        options={customVariableList?.custom_variable_data ? [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), {
                                            chatbot_custom_variable_configuration_id: "-1",
                                            chatbot_custom_variable_name: "New Field",
                                            chatbot_custom_variable_fallback_value: "",
                                            flag_archived: false
                                        }] : []}
                                        getOptionLabel={(option) => option.chatbot_custom_variable_name || ''}
                                        value={customVariableList?.custom_variable_data?.find((field: any) => field.chatbot_custom_variable_configuration_id == payloadKey.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) || null}
                                        onChange={(e: React.SyntheticEvent, value: any) => {
                                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...payloadKey, type: 'change_payload_config', action_data: { ...payloadKey.action_data, chatbot_custom_variable_configuration: value } },
                                                {
                                                    updateType: "editExistingStepAction"
                                                }

                                            )
                                        }}

                                        ListboxProps={{ style: { maxHeight: '150px', overflow: 'auto', paddingBottom: "50px" } }}

                                        renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: customVariableDataInterface) => { return renderOptions(props, option); }}
                                        renderInput={params => {
                                            const { InputProps, ...restParams } = params;
                                            const { startAdornment, ...restInputProps } = InputProps;
                                            return (
                                                <TextField
                                                    {...restParams}
                                                    placeholder='Select Field'
                                                    InputProps={{
                                                        ...restInputProps,
                                                        startAdornment: (
                                                            <div style={{
                                                                maxHeight: "90px",
                                                                overflowY: 'auto',
                                                            }}
                                                            >
                                                                {startAdornment}
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                </TableCell>
                                {actionData.length > 1 &&
                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                        <CloseIcon
                                            sx={{ display: "flex", height: "22px", width: "22px", cursor: "pointer", justifySelf: "right" }}
                                            onClick={() => {
                                                onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...stepAction, type: "remove_payload_key", keyToBeRemoved: payloadKey.chatbot_step_action_id },
                                                    {
                                                        updateType: "editExistingStepAction"
                                                    }
                                                )
                                            }}
                                        />
                                    </TableCell>
                                }
                            </TableRow>
                        })
                        }

                    </TableBody>
                </Table>
            </TableContainer> */}
        </Grid>

    )
}

export default PayloadFieldTable